import { DOWNLOAD_BOOKING_V2, DOWNLOAD_BOOKING_V2_SUCCESS, DOWNLOAD_BOOKING_V2_ERROR, DOWNLOAD_BOOKING_V2_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const DownloadDumpV2 = (state = initialState, action) => {
  switch (action.type) {
    case DOWNLOAD_BOOKING_V2:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case DOWNLOAD_BOOKING_V2_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case DOWNLOAD_BOOKING_V2_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case DOWNLOAD_BOOKING_V2_EMPTY:
      state = {
        data: null,
        message: null,
        loading: false,
        success: false,
        error: false,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default DownloadDumpV2;
